import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "g1",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": "Head west across the battlefield",
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "player-spawn"}),
                ]
            },
            {
                "type": "turn:every-odd:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "enemy1-spawn",
                        "protounit": {
                            "randomJobKey": "sword,gun,bow,spear",
                            "affiliation": "bad",
                        }
                    }),
                    PlotSteps.SpawnUnitAtSpot({
                        "spotTag": "enemy2-spawn",
                        "protounit": {
                            "randomJobKey": "sword,gun,bow,spear",
                            "affiliation": "neutral",
                        }
                    }),
                ]
            },
            {
                "type": "turn:every-even:end",
                "events": [
                    PlotSteps.EscapeScript({"spotTag": "player-exit"}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 2, "spotTag": "player-spawn"})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 2
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.HealPlayerPartyScript(),
                    PlotSteps.MoveEncounterScript({"nextEncounterKey": 3, "spotTag": "player-spawn"})
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 3
                        && PlotConditions.hasEscaped(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war/chapters/g2")},
                ]
            },
            {
                "type": "condition",
                "condition": function(stage) {
                    return PlotConditions.areAllAffiliatedUnitsDefeated(stage, {"affiliation": "good"})
                },
                "events": [
                    PlotSteps.ChapterFailure(),
                    {"func": () => App.game.chapter.restart()},
                ]
            }
        ]
    },
}
